import { ThemeSchemaResponse } from '@api/api/theme-overview';
import { ErrorBoundaryWrapper } from '@terminal/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { MacroFinancialAboutSection } from '@terminal/views/theme-overview/tab-content/overview-financial-macro/about-section/MacroFinancialAboutSection';
import { FinancialSectorDistributionSection } from '@terminal/views/theme-overview/tab-content/overview-financial-macro/distribution-section/FinancialSectorDistributionSection';
import { IndustryThemesSection } from '@terminal/views/theme-overview/tab-content/overview-financial-macro/industry-themes-section/IndustryThemesSection';
import { MacroFinancialTopCompaniesSection } from '@terminal/views/theme-overview/tab-content/overview-financial-macro/top-companies-section/MacroFinancialTopCompaniesSection';

import styles from './FinancialDrawerContent.module.scss';

export interface FinancialDrawerContentProps {
  theme: ThemeSchemaResponse;
}

export const FinancialDrawerContent = ({
  theme,
}: FinancialDrawerContentProps) => {
  return (
    <div className={styles.root}>
      <section>
        <ErrorBoundaryWrapper showBorder={false} resetKeys={[theme.id]}>
          <MacroFinancialAboutSection theme={theme} isCompact />
        </ErrorBoundaryWrapper>
      </section>
      <section>
        <ErrorBoundaryWrapper showBorder={false} resetKeys={[theme.id]}>
          <FinancialSectorDistributionSection theme={theme} isCompact />
        </ErrorBoundaryWrapper>
      </section>
      <section>
        <ErrorBoundaryWrapper showBorder={false} resetKeys={[theme.id]}>
          <MacroFinancialTopCompaniesSection theme={theme} isCompact />
        </ErrorBoundaryWrapper>
      </section>
      <section>
        <ErrorBoundaryWrapper showBorder={false} resetKeys={[theme.id]}>
          <IndustryThemesSection theme={theme} isCompact />
        </ErrorBoundaryWrapper>
      </section>
    </div>
  );
};
